/**
 * Order Confirmation Page
 */
'use strict';

const gMap = require('../../modules/google').maps;
const gPlaces = require('../../modules/google').places;
const $mapEl = $('.js-google-map');
const miniCart = require('../../minicart');

/**
 * Gets data from map element and converts them to coordinates
 */
const initMap = () => {
    if (drawMap()) {
        return;
    }

    const postalCode = String($mapEl.data('postalcode') || '');
    const countryName = $mapEl.data('country') || '';

    gPlaces.getLatLongFromPostalCode(postalCode, countryName, function(lat, lng) {
        if (lat && lng) {
            $mapEl.data('lat', lat);
            $mapEl.data('lng', lng);

            drawMap();
        }
    });
};

/**
 * Draws the map in the map element using the lat and lng params
 *
 * @param {number} lat lattitude of location
 * @param {number} lng longtitude of location
 */
const drawMap = () => {
    if ($mapEl.data('lat') && $mapEl.data('lng')) {
        if ($mapEl.data('icon')) {
            // Checkout V3
            const lat = $mapEl.data('lat');
            const lng = $mapEl.data('lng');
            const icon = $mapEl.data('icon');
            const center = new google.maps.LatLng(lat, lng);

            // Google Map Style source: https://snazzymaps.com/style/14889/flat-pale
            gMap.init($mapEl, {
                    url: icon,
                    scaledSize: new google.maps.Size(35, 48)
                }, {
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    center: center,
                    zoom: 15,
                    panControl: false,
                    zoomControl: true,
                    mapTypeControl: false,
                    scaleControl: false,
                    streetViewControl: false,
                    overviewMapControl: false,
                    rotateControl: false,
                    styles: [
                        {
                            'featureType': 'administrative',
                            'elementType': 'labels.text.fill',
                            'stylers': [
                                {
                                    'color': '#6195a0'
                                }
                            ]
                        },
                        {
                            'featureType': 'administrative.province',
                            'elementType': 'geometry.stroke',
                            'stylers': [
                                {
                                    'visibility': 'off'
                                }
                            ]
                        },
                        {
                            'featureType': 'landscape',
                            'elementType': 'geometry',
                            'stylers': [
                                {
                                    'lightness': '0'
                                },
                                {
                                    'saturation': '0'
                                },
                                {
                                    'color': '#f5f5f2'
                                },
                                {
                                    'gamma': '1'
                                }
                            ]
                        },
                        {
                            'featureType': 'landscape.man_made',
                            'elementType': 'all',
                            'stylers': [
                                {
                                    'lightness': '-3'
                                },
                                {
                                    'gamma': '1.00'
                                }
                            ]
                        },
                        {
                            'featureType': 'landscape.natural.terrain',
                            'elementType': 'all',
                            'stylers': [
                                {
                                    'visibility': 'off'
                                }
                            ]
                        },
                        {
                            'featureType': 'poi',
                            'elementType': 'all',
                            'stylers': [
                                {
                                    'visibility': 'off'
                                }
                            ]
                        },
                        {
                            'featureType': 'poi.park',
                            'elementType': 'geometry.fill',
                            'stylers': [
                                {
                                    'color': '#bae5ce'
                                },
                                {
                                    'visibility': 'on'
                                }
                            ]
                        },
                        {
                            'featureType': 'road',
                            'elementType': 'all',
                            'stylers': [
                                {
                                    'saturation': -100
                                },
                                {
                                    'lightness': 45
                                },
                                {
                                    'visibility': 'simplified'
                                }
                            ]
                        },
                        {
                            'featureType': 'road.highway',
                            'elementType': 'all',
                            'stylers': [
                                {
                                    'visibility': 'simplified'
                                }
                            ]
                        },
                        {
                            'featureType': 'road.highway',
                            'elementType': 'geometry.fill',
                            'stylers': [
                                {
                                    'color': '#fac9a9'
                                },
                                {
                                    'visibility': 'simplified'
                                }
                            ]
                        },
                        {
                            'featureType': 'road.highway',
                            'elementType': 'labels.text',
                            'stylers': [
                                {
                                    'color': '#4e4e4e'
                                }
                            ]
                        },
                        {
                            'featureType': 'road.arterial',
                            'elementType': 'labels.text.fill',
                            'stylers': [
                                {
                                    'color': '#787878'
                                }
                            ]
                        },
                        {
                            'featureType': 'road.arterial',
                            'elementType': 'labels.icon',
                            'stylers': [
                                {
                                    'visibility': 'off'
                                }
                            ]
                        },
                        {
                            'featureType': 'transit',
                            'elementType': 'all',
                            'stylers': [
                                {
                                    'visibility': 'simplified'
                                }
                            ]
                        },
                        {
                            'featureType': 'transit.station.airport',
                            'elementType': 'labels.icon',
                            'stylers': [
                                {
                                    'hue': '#0a00ff'
                                },
                                {
                                    'saturation': '-77'
                                },
                                {
                                    'gamma': '0.57'
                                },
                                {
                                    'lightness': '0'
                                }
                            ]
                        },
                        {
                            'featureType': 'transit.station.rail',
                            'elementType': 'labels.text.fill',
                            'stylers': [
                                {
                                    'color': '#43321e'
                                }
                            ]
                        },
                        {
                            'featureType': 'transit.station.rail',
                            'elementType': 'labels.icon',
                            'stylers': [
                                {
                                    'hue': '#ff6c00'
                                },
                                {
                                    'lightness': '4'
                                },
                                {
                                    'gamma': '0.75'
                                },
                                {
                                    'saturation': '-68'
                                }
                            ]
                        },
                        {
                            'featureType': 'water',
                            'elementType': 'all',
                            'stylers': [
                                {
                                    'color': '#eaf6f8'
                                },
                                {
                                    'visibility': 'on'
                                }
                            ]
                        },
                        {
                            'featureType': 'water',
                            'elementType': 'geometry.fill',
                            'stylers': [
                                {
                                    'color': '#c7eced'
                                }
                            ]
                        },
                        {
                            'featureType': 'water',
                            'elementType': 'labels.text.fill',
                            'stylers': [
                                {
                                    'lightness': '-49'
                                },
                                {
                                    'saturation': '-53'
                                },
                                {
                                    'gamma': '0.79'
                                }
                            ]
                        }
                    ]
                });
        } else {
            // Checkout V2
            gMap.init($mapEl);
        }
        return true;
    }
    return false;
};

/**
 * Checks if a map is present
 *
 * @returns {boolean}
 */
const shouldInitMap = () => {
    return $mapEl.length > 0;
};

const orderConfirmationPage = {
    init: () => {
        $(document).find('.js-acc-head').on('opened', miniCart.adjustPricePadding);
        $(document).find('.js-acc-head').on('click', function() {
            const accLabel = $(this).find('.js-order-summary-accordian');
            const temp = accLabel.data('toggle-label');
            accLabel.data('toggle-label', accLabel.text());
            accLabel.text(temp);
        });
        if (shouldInitMap()) {
            initMap();
        }
    }
};


module.exports = orderConfirmationPage;
